import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";

export const GTMNotificationEvent = (eventName: string, custom = {}) => {
  dataLayer(eventName, custom, ["timestamp", "userType", "userId"]);
};
